import React from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { useNavigate } from "react-router-dom";

interface Props {
  show: boolean;
  onClose: () => void;
}

const FullTrustapAccountRequiredPopup: React.FC<Props> = ({ show, onClose }) => {
  const navigate = useNavigate();

  const handleSetUp = () => {
    onClose();
    navigate("/dashboard/trustap-account");
  };

  return (
    <Modal
      show={show}
      onHide={onClose}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      dialogClassName="confirmModal"
    >
      <Modal.Body>
        <div className="confirmModal__icon">
          <i className="bi bi-shield-lock" aria-hidden="true" />
        </div>
        <h2 className="confirmModal__title">Full Trustap account required</h2>
        <p className="confirmModal__subtitle">
          To claim payouts you need a <strong>full</strong> Trustap account.
          A guest account is enough to receive payments, but not to withdraw
          them.
        </p>

        <div className="confirmModal__details">
          <div className="confirmModal__detailRow">
            <i className="bi bi-person-badge" aria-hidden="true" />
            <span>
              Trustap will ask you to verify your identity and add payout
              details (bank account or card).
            </span>
          </div>
          <div className="confirmModal__detailRow">
            <i className="bi bi-clock-history" aria-hidden="true" />
            <span>
              Setup takes a few minutes. You only have to do it once.
            </span>
          </div>
          <div className="confirmModal__detailRow">
            <i className="bi bi-info-circle" aria-hidden="true" />
            <span>
              Learn more in the{" "}
              <a
                href="https://docs.trustap.com/docs/guides/transactions/online/online-int-path-banktransfer#seller-claims-transaction"
                target="_blank"
                rel="noreferrer"
              >
                Trustap claim guide
              </a>
              .
            </span>
          </div>
        </div>

        <div className="confirmModal__footer">
          <Button className="closeBtn" variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <button
            type="button"
            className="confirmModal__primary"
            onClick={handleSetUp}
          >
            Set up full account
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default FullTrustapAccountRequiredPopup;
